module.exports = __webpack_public_path__ + "media/images/emblems/Begnins-coat_of_arms-c972eb7977b843f842a88d1c00d16289.svg";